import { useEffect, useState } from 'react';
import Button from '@mui/joy/Button';
import Stack from '@mui/joy/Stack';

import useUserIdentity from 'hooks/useUserIdentity';
import useCreditLog from 'hooks/useCreditLog';
import useRoles from 'hooks/useRoles';
import { CreditLogProps } from 'stores/credit_log_store';
import { PagedResult } from 'utils/types';
import { CreditLogList } from 'components/CreditLog';
import Success from 'components/Success';

const SupportCreditLog = (({userUuid}: {userUuid: string}) => {
    const { rolesNames } = useRoles();
    const { currentIdentity } = useUserIdentity();
    const [creditLog, setCreditLog] = useState([] as CreditLogProps[]);
    const isSupport = rolesNames.includes('support');
    const { fetchCreditLogViaSupport } = useCreditLog();
    const [cursor, setCursor] = useState('');
    function doFetch (notify?: boolean) {
        fetchCreditLogViaSupport(currentIdentity.uuid, userUuid, cursor)
            .then((log: PagedResult<CreditLogProps>) => {
                if(log.cursor) {
                    setCursor(log.cursor);
                }
                setCreditLog([...creditLog, ...log.items]);
                if(notify) {
                    Success("Loaded");
                }
            });

    }
    useEffect(() => {
        if(!isSupport) return;
        doFetch();
    },[fetchCreditLogViaSupport, currentIdentity.uuid, userUuid, isSupport]);



    if(!isSupport)
        return null;

    if(!creditLog)
        return "no credit log?"

  return (
    <div>
        <CreditLogList logItems={creditLog} />
        <Stack direction="row" justifyContent="center">

            <Button variant="plain" onClick={() => doFetch(true)}> Load More</Button>
        </Stack>
    </div>
  );
});

export default SupportCreditLog;
